/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/travel-guide.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Travel Guide',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.5 4.375C22.0502 4.375 20.875 5.55025 20.875 7V9.375H14.4425C13.8885 9.375 13.3622 9.61708 13.0016 10.0377L10.2354 13.265C9.62626 13.9757 9.62626 15.0243 10.2354 15.735L13.0016 18.9623C13.3622 19.3829 13.8885 19.625 14.4425 19.625H20.875V22.375H12.2727C11.2246 22.375 10.375 23.2246 10.375 24.2727V30.7273C10.375 31.7754 11.2246 32.625 12.2727 32.625H20.875V42C20.875 42.2071 20.7071 42.375 20.5 42.375H19C18.6548 42.375 18.375 42.6548 18.375 43C18.375 43.3452 18.6548 43.625 19 43.625H20.5C21.3975 43.625 22.125 42.8975 22.125 42V32.625H25.875V42C25.875 42.8975 26.6025 43.625 27.5 43.625H29C29.3452 43.625 29.625 43.3452 29.625 43C29.625 42.6548 29.3452 42.375 29 42.375H27.5C27.2929 42.375 27.125 42.2071 27.125 42V32.625H33.5575C34.1115 32.625 34.6378 32.3829 34.9983 31.9623L37.7646 28.735C38.3737 28.0243 38.3737 26.9757 37.7646 26.265L34.9983 23.0377C34.6378 22.6171 34.1115 22.375 33.5575 22.375H27.125V19.625H35.7273C36.7754 19.625 37.625 18.7754 37.625 17.7273V11.2727C37.625 10.2246 36.7754 9.375 35.7273 9.375H27.125V7C27.125 5.55025 25.9497 4.375 24.5 4.375H23.5ZM25.875 9.375V7C25.875 6.24061 25.2594 5.625 24.5 5.625H23.5C22.7406 5.625 22.125 6.24061 22.125 7V9.375H25.875ZM25.875 19.625H22.125V22.375H25.875V19.625ZM14.4425 10.625C14.2534 10.625 14.0738 10.7076 13.9507 10.8512L11.1845 14.0785C10.9766 14.321 10.9766 14.679 11.1845 14.9215L13.9507 18.1488C14.0738 18.2924 14.2534 18.375 14.4425 18.375H35.7273C36.085 18.375 36.375 18.085 36.375 17.7273V11.2727C36.375 10.915 36.085 10.625 35.7273 10.625H14.4425ZM33.5575 23.625C33.7466 23.625 33.9262 23.7076 34.0493 23.8512L36.8155 27.0785C37.0234 27.321 37.0234 27.679 36.8155 27.9215L34.0493 31.1488C33.9262 31.2924 33.7466 31.375 33.5575 31.375H12.2727C11.915 31.375 11.625 31.085 11.625 30.7273V24.2727C11.625 23.915 11.915 23.625 12.2727 23.625H33.5575Z"
            fill="#333333"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
